import {
  React,
  Component,
} from 'imports/CommonImports';

import {
  Paper,
  Divider
} from 'material-ui';

import {CircleIcon} from 'imports/IconsImports';

import {SecondaryButton} from 'imports/DesignImports';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FBFBFB',
    boxSizing: 'none',
  },
  top: {
    display: 'flex',
    alignItems: 'center',
    height: '1.5em',
    backgroundColor: '#F0F0EF',
    marginRight: '0.1px'
  },
  headerContainer: {
    minHeight: '2em',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '1em',
  },
  infoContainer: {
    minHeight: '5em',
    padding: '0 1em',
  },
  buttonContainer: {
    minHeight: '2em',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '1em',
  },
  button: {
    borderRadius: '25px',
    fontFamily: 'Lato',
  },
  seeDiv: {
    position: 'relative',
    bottom: '-1.6em',
    cursor: 'pointer',
  }
}

class StageBox extends Component {

  render() {
    return (
      this.getContent()
    );
  }

  getContent = () => {
    if (!this.props.active && this.props.pending) {
      return(
        <Paper zDepth={1} style={{...styles.container, ...this.props.style}}>
          <div style={styles.top}>
            <div className='p2' style={{paddingLeft:'1em'}}>Sin información</div>
          </div>
          <div style={styles.headerContainer}>
            <h2 >
              {this.props.header}
            </h2>
          </div>
          <Divider/>
          <div style={styles.infoContainer}>
            <p>
              {this.props.pending ? this.props.pendingInfo : this.props.info}
            </p>
          </div>
          <div style={styles.buttonContainer}>
          </div>
        </Paper>
      );
    }
    else if(this.props.active && this.props.pending){
      return(
        <Paper zDepth={1} style={{...styles.container, ...this.props.style, ...{border: '3px solid #212F55'}}}>
          <div style={styles.top}>
            <CircleIcon style={{color: '#FF952B'}}/> <div className='p2'>Tareas pendientes</div>
          </div>
          <div style={styles.headerContainer}>
            <h2 >
              {this.props.header}
            </h2>
          </div>
          <Divider/>
          <div style={styles.infoContainer}>
            <p>
              {this.props.info}
            </p>
          </div>
          <div style={styles.buttonContainer}>
            <SecondaryButton label='Seleccionar' onClick={this.props.buttonAction} />
          </div>
        </Paper>
      );
    }
    else{
      return(
        <Paper onClick={this.props.buttonAction} zDepth={1} style={{...styles.container, ...this.props.style, ...{cursor: 'pointer'}}}>
          <div style={styles.top}>
            <CircleIcon style={{color: '#11AB99'}}/> <div className='p2'>Completado</div>
          </div>
          <div style={styles.headerContainer}>
            <h2 >
              {this.props.header}
            </h2>
          </div>
          <Divider/>
          <div style={styles.infoContainer}>
            <p>
              {this.props.info}
            </p>
          </div>
          <div style={styles.buttonContainer}>
            <div style={styles.seeDiv} >Ver</div>
          </div>
        </Paper>
      );
    }
  }
}

export default StageBox;



// WEBPACK FOOTER //
// ./src/components/common/StageBox.js